import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Button from "../../../../components/button";
// import Tabs from "../../../components/tabs";
// import TabPanel from "../../../components/tabs/tabpanel";
// import IntermediateFeedback from "./intermediateclientfeedback";
// import PartnerFeedback from "./partnerfeedback";
// import ProfessionalFeedback from "./professionalclientfeedback";

import Search from "../../../../components/search";
// import { list } from "./data";
import {
  setFeedBacks,
  setFeedbackPage,
  setFeedbackrowsPerPage,
} from "../../../../reducer/adminSlice";
import {
  deleteFeedbackById,
  filterAllFeedbacks,
  getFeedbacks,
  getPracticeFeedbacks,
  getsnglefeedback,
  exportFeedBackData
} from "../../../../services/admin";
import InfoPopup from "../../../../components/infopopup";
import "../feedback.css";
import { toast } from "react-toastify";
import EditFeedback from "../subcomponent/editfeedback";
import PublishFeedback from "../subcomponent/publishfeedback";
import { Link, useNavigate } from "react-router-dom";
import CsvDownload from "../../../../components/csvdownload";
import { filterList } from "../data";
import { setLoading } from "../../../../reducer/auth/auth";
import Pagination from "../../../../components/tablePagination";


export default function AllFeedback() {
  const {
    feedBacks,
    feedbackPage,
    feedbackrowsPerPage,
    globalRowsPerPage,
  } = useSelector((state) => state.users);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [activeTab, setActiveTab] = useState(0);
  const [localFeedBacks, setLocalFeedBacks] = useState([]);
  const [active, setActive] = useState([]);
  const [editFeedbackDetail, setEditFeedbackDetail] = useState();
  const [localFeedBacksstatus, setLocalFeedBacksstatus] = useState([]);
  const [searchValue, setSearchValues] = useState();
  const [filterValues, setFilterValues] = useState("screen_name");
  const [sessionType, setSessionType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords =
    localFeedBacks;
  const nPages =
    localFeedBacks.length > 0
      ? Math.ceil(localFeedBacks.length / recordsPerPage)
      : "";

  const [totalcount, setTotalCount] = useState(0);


  useEffect(() => {
    callBack();
  }, []);
  useEffect(() => {
    // let response = feedBacks

    let info = feedBacks.map((data) => {
      return false;
    });

    // let newa = [...feedBacks].length > 0 && [...feedBacks].sort(function (a, b) {

    //   return new Date(Object.values(b).length > 1 ? Object.values(b)[1].date : Object.values(b)[0].date) - new Date(Object.values(a).length > 1 ? Object.values(a)[1].date : Object.values(a)[0].date);
    // });
    setLocalFeedBacksstatus(info);
    // console.log(feedBacks, "feedBacks");
    setLocalFeedBacks(feedBacks);
    // console.log(newa, "newa")
  }, [feedBacks]);

  // useEffect(() => {
  //   if (feedBacks.length > 0) {
  //     const groupedFeedbacks = groupBy(feedBacks, "appointment");
  //     const groupedArray = Object.values(groupedFeedbacks).map((group) => {
  //       return Object.assign({}, group);
  //     });
  //     setLocalFeedBacks(groupedArray);
  //     setLocalFeedBacksstatus(new Array(groupedArray.length).fill(false));
  //   }
  // }, [feedBacks]);

  function groupBy(objectArray, property) {
    return objectArray.reduce(function (accumulator, currentObject) {
      let key = currentObject[property];
      if (!accumulator[key]) {
        accumulator[key] = [];
      }
      accumulator[key].push(currentObject);
      return accumulator;
    }, {});
  }

  const callBack = (dat, activeTab) => {
    dispatch(setLoading(true));
    // console.log('working')
    console.log("wori");
    getFeedbacks(dat, activeTab)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          setTotalCount(data.data.data.total);


          // let obj = Object.values(grouped).map((val) => {
          //   return Object.assign({}, val);
          // });
          console.log(dat, "obj");
          // dispatch(setFeedbackPage(dat !== undefined ? dat.page : feedbackPage));
          // dispatch(setFeedbackrowsPerPage(dat !== undefined ? dat.rowsPerPage : feedbackrowsPerPage));
          dispatch(setFeedBacks(data.data.data.data));
        }
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const openMoreInfo = (info) => {
    let array = [];
    const coachingCheck = info && info[0] && info[0].session_type;
    setSessionType(info);

    if (coachingCheck === "Coaching") {
      const feedback = info[0] && info[0].feedback;
      if (feedback) {
        array = [
          {
            "1. What do you want other Mediums to know about this coach?": feedback.answer_1 || "",
            "2. What 3 words best describe this coach?": "",
            "2.1": feedback.answer_21 || "",
            "2.2": feedback.answer_22 || "",
            "2.3": feedback.answer_23 || "",
            "3. How did this session help advance your mediumship?": feedback.answer_3 || "",
            "4. Any additional private message to your coach?": feedback.answer_4 || "",
          },
        ];
      }
    } else {
      Object.values(info).forEach((item) => {
        array.push(item.feedback);
      });
    }

    setActive(array);
    window.loadModal2("#infopopup", "show");
  };

  const deleteFeedback = (id) => {



    // setLocalFeedBacks
    let body = {
      id: id,
    };
    deleteFeedbackById(body)
      .then((data) => {
        if (data.data.status) {

          console.log(localFeedBacks, "localFeedBacks")
          // const filtered = localFeedBacks.filter((item) => parseInt(item.appointment_id) !== parseInt(id));
          // setLocalFeedBacks(filtered);
          setLocalFeedBacks((prev) => {
  const filtered = prev.filter(
    (item) => parseInt(item.feedback_id) !== parseInt(id)
  );

  setLocalFeedBacksstatus(new Array(filtered.length).fill(false));
  return filtered;
});
          // callBack();
          toast.success("Feedback deleted successfully", {
            position: "top-center",
          });
        }
      })
      .catch(() => {
        toast.error("Error deleting feedback", { position: "top-center" });
      });
  };
  const onEditFeedback = (item) => {
    console.log(item, "item");
    setEditFeedbackDetail([item]);
    // window.loadModal2('#editFeedback', 'show');
    window.loadModal2("#publishFeedback", "show");
  };
  const onClickHandler = (e, index) => {
    console.log(localFeedBacksstatus);
    let info = localFeedBacksstatus.map((data, i) => {
      if (i === index) {
        return !data;
      } else {
        return false;
      }
    });

    setLocalFeedBacksstatus(info);
  };
  const checkObjectLendth = (item, info) => {
    if (item && item.feedback && item.feedback[info] !== undefined && item.feedback[info] !== null) {
      return item.feedback[info];
    }
    return ""; // Return an empty string as a fallback
  };
  const navigateEditClient = (e, id) => {
    if (e.target.tagName === "LABEL" || e.target.tagName === "INPUT") {
    } else {
      navigate(`/edit/${id.client_id}`);
    }
  };

  const navigateEditMedium = (e, id) => {
    if (e.target.tagName === "LABEL" || e.target.tagName === "INPUT") {
    } else {
      navigate(`/profile-edit/${id.medium_id}`);
    }
  };
  const filterFeedbacks = (constants) => {
    const {
      name = "",
      session_id = "",
      screen_name = "",
      medium_email = "",
      client_email = "",
      session_name = "",
      created_at = ""
    } = constants;
    let newId = session_id


    let body = {
      name,
      newId,
      screen_name,
      medium_email,
      client_email,
      session_name,
      created_at,
    };
    filterAllFeedbacks(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(setFeedbackPage(feedbackPage + 1));
          dispatch(setFeedbackrowsPerPage(globalRowsPerPage));
          setTotalCount(data.data.data.total);
          // let grouped = groupBy(data.data.data.data, "appointment");
          // // let array = [];
          // let obj = Object.values(grouped).map((val) => {
          //   return Object.assign({}, val);
          // });
          dispatch(setFeedBacks(data.data.data.data));
          // dispatch(setAllOutreachClientsCount(data.data.data.total));
        }
      })
      .catch(() => { });
    // }
  };
  const getFeedback = (appoinment) => {
    dispatch(setLoading(true));
    getsnglefeedback(appoinment.appointment_id)
      .then((data) => {
        if (data.data.status) {
          let info = data.data.data;
          console.log(data.data.data, "data.data.data ");
          var coachingCheck = info && info[0].session_type;
          let array = [];
          if (coachingCheck == "Coaching") {
            var feedback = info && info[0].feedback;
            if (feedback) {
              array = [{
                '1. What do you want other Mediums to know about this coach?': feedback && feedback.answer_1 ? feedback.answer_1 : "",
                '2. What 3 words best describe this coach?': "",
                '2.1': feedback && feedback.answer_21 ? feedback.answer_21 : "",
                '2.2': feedback && feedback.answer_22 ? feedback.answer_22 : "",
                '2.3': feedback && feedback.answer_23 ? feedback.answer_23 : "",
                '3. How did this session help advance your mediumship?': feedback && feedback.answer_3 ? feedback.answer_3 : "",
                '4. Any additional private message to your coach?': feedback && feedback.answer_4 ? feedback.answer_4 : "",
              }];
              setActive(array);
            }
          } else {
            Object.values(info).map((item) => {
              array.push(item.feedback);
              
            });
            console.log(array, "array");
            setActive(array);
          }
          setSessionType(info);
          window.loadModal2("#infopopup", "show");
        }
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };
  const getPaginationData = (data, activeTab) => {
    let dat = {
      ...data,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_name:
        searchValue !== undefined
          ? searchValue.session_name !== undefined
            ? searchValue.session_name
            : ""
          : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      newId:
        searchValue !== undefined
          ? searchValue.session_id !== undefined
            ? searchValue.session_id
            : ""
          : "",
      created_at: searchValue !== undefined
        ? searchValue.created_at !== undefined
          ? searchValue.created_at
          : ""
        : "",
    };

    callBack(dat, activeTab);
  };
   const exportData =()=>{
    let date = searchValue !== undefined
            ? searchValue.created_at !== undefined
              ? searchValue.created_at
              : ""
            : "";
       let info = {
              session_type: 5, survey_date: date
          }
      exportFeedBackData(info).then((data) => {
              if (data.data.status) {
                  toast.success(data.data.message, { position: "top-center" });
              }
              }).catch(() => { })
    }
  return (
    <>
      <div className="d-flex justify-content-end gap-10 flex-wrap">
        <Search
          callApi={filterFeedbacks}
          list={filterList}
          setSearchValues={setSearchValues}
          setFilterValues={setFilterValues}
          searchValue={searchValue}
          filterValues={filterValues}
          isDatepickerShow={1}
          oneDayAdded={1}
        />
      </div>
      <Button
              status={0}
              type="button"
              onClick={exportData}
              className="resend-btn min-width-135 create-app-sm-screen"
              title="Export Table"
            />
      {/* <CsvDownload
        href={
          `${process.env.REACT_APP_API_URL_EXPORT}` + `export-feedback-list?session_type=5&survey_date=${searchValue !== undefined
            ? searchValue.created_at !== undefined
              ? searchValue.created_at
              : ""
            : ""}`
        } */}
      {/* //  data={fireFilter(clients)} headers={headers} filename={'starterClients'}
      // usertype={"outreach"} */}
      {/* /> */}
      <div className="dashboard">
        <div className="row">
          <div className="col-md-12">
            <div className="my-ppointments-box appoint-das">
              <div className="table-box-medium admin-feed-page overflow-scroll feedback-table">
                <table className="caseTable">
                  <thead>
                    <tr className="dark">
                      <th rowspan="1">Session #</th>
                      <th rowspan="1">Medium Screen Name</th>
                      <th rowspan="1">Client Screen Name</th>
                      <th rowspan="1">Session Date</th>
                      <th rowspan="1">Survey Date</th>
                      <th className="text-center" colSpan="3">
                        Scores
                      </th>
                      <th className="text-center" colspan="3">
                        Comments
                      </th>
                      <th rowspan="1">Session Type</th>

                      <th rowspan="1">Actions</th>
                    </tr>
                    <tr className="dark dark-subheading">
                      <th className="white-background">&nbsp;</th>
                      <th className="white-background">&nbsp;</th>
                      <th className="white-background">&nbsp;</th>
                      <th className="white-background">&nbsp;</th>
                      <th className="white-background">&nbsp;</th>
                      <th className="">E</th>
                      <th className="">M</th>
                      <th className="">R</th>
                      <th className="">VerySoul Public View</th>
                      <th className="">Confidential Note to You</th>
                      <th className="">About</th>
                      <th className="white-background">&nbsp;</th>
                      <th className="white-background">&nbsp;</th>
                      <th className="white-background">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.length > 0 ? (
                      currentRecords.map((item, index) => (
                        <tr className="innr">
                          <td className="min-width-100">
                            {item.front_appointment_id}
                            {item.is_refunded ? 
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="#f0ad4e"
                              viewBox="0 0 24 24"
                              style={{ marginRight: "6px" }}
                            >
                              <path d="M12 5V2L7 7l5 5V9c3.31 0 6 2.69 6 6a6 6 0 01-6 6 6 6 0 01-5.65-4H4.26A8 8 0 0012 21a8 8 0 000-16z"/>
                            </svg>
                            :""}
                            {item.give_add1_highlight == 1 ? <img className="ml-1 star-app-hightlight" src="../images/star.png" /> : ''}
                          </td>
                          <td
                            className="pointer feedback-urls min-width-125"
                            onClick={(e) => navigateEditMedium(e, item)}
                          >
                            {item.screen_name}
                            {item.medium_comment === true && (<b style={{
                              fontSize: '22px',
                            }}>*</b>)}
                          </td>
                          <td
                            className="pointer feedback-urls min-width-125"
                            onClick={(e) => navigateEditClient(e, item)}
                          >
                            {" "}
                            {item.client_name}
                            {item.client_comment === true && (<b style={{
                              fontSize: '22px',
                            }}>*</b>)}
                          </td>
                          <td className="min-width-120">
                            {item.session_date}
                            {/* {moment(item.session_time, ["h:mm A"]).format(
                              "hh:mm a"
                            )} */}
                          </td>
                          {/* <td className="min-width-120">{moment.utc(item.date).format("LL")}</td> */}
                          <td className="min-width-120">{item.date}</td>

                          {/* <td className="">
                            {moment(item.session_time, ["h:mm A"]).format(
                              "hh:mm a"
                            )}
                          </td> */}
                          <td className="font-size-14">
                            {checkObjectLendth(
                              item,
                              "recognized_my_loved_one_from_evidence"
                            )}
                          </td>
                          <td className="font-size-14">
                            {checkObjectLendth(item, "meaningful_experience")}
                          </td>
                          <td className="font-size-14">
                            {checkObjectLendth(item, "recommend_To_others")}
                          </td>
                          <td className="min-width-300 font-size-14">
                            {checkObjectLendth(item, "overall_impression")}
                          </td>
                          <td className="min-width-300 font-size-14">
                            {checkObjectLendth(item, "additional_feedback")}
                          </td>
                          <td className="min-width-300 font-size-14">
                            {checkObjectLendth(item, "about_verysoul")}
                          </td>

                          <td className="min-width-125">{item.session_type}</td>

                          {/* <td className="action-btn-feedbacks"> */}
                          <td className="dott">
                            <img
                              onClick={(e) => onClickHandler(e, index)}
                              src="/images/Unionblck.png"
                              className="padding-10 pointer"
                              alt="dots"
                            />
                            {localFeedBacksstatus[index] && (
                              <div className="approve-btn-1 approve-btn z-index-1">
                                {item.session_type !== "Coaching" && (
                                  <span
                                    onClick={() => onEditFeedback(item)}
                                    className="pointer"
                                  >
                                    Edit
                                  </span>
                                )}
                                <span
                                  onClick={() =>
                                    deleteFeedback(item.feedback_id)
                                  }
                                >
                                  Delete
                                </span>
                                <span
                                  // onClick={() => openMoreInfo(item)}
                                  onClick={() => getFeedback(item)}
                                >
                                  View
                                </span>
                              </div>
                            )}
                            {/* <img
                              onClick={() => onEditFeedback(item)}
                              className="pointer w-20-px"
                              src="images/icon-feather-edit.png"
                              alt="edit"
                            />
                            <img
                              onClick={() => deleteFeedback(item.appointment_id)}
                              className="pointer"
                              src="../images/icon-b2.png"
                              alt="delete"
                            />
                            <img
                              title="More"
                              onClick={() => openMoreInfo(item)}
                              className="pointer"
                              src="/localImages/openeye.svg"
                              alt="eye"
                            /> */}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={12} className="text-center">
                          No Feedbacks Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <PublishFeedback
          editFeedbackDetail={editFeedbackDetail}
          callBack={callBack}
        />
        {/* <EditFeedback editFeedbackDetail={editFeedbackDetail} callBack={callBack} /> */}
        <InfoPopup feedBackinfo={active} sessionType={sessionType} />

        <Pagination
          rowsPerPageOptions={[25,50,100]}
          activeTab={"adminfeedback"}
          count={totalcount}
          getPaginationData={getPaginationData}
        />
      </div>
    </>
    // <div className="all-medium-page">
    //   <Tabs list={list} setActiveTab={setActiveTab} />
    //   <ul className="tabs-content">
    //     <TabPanel id={0} activeTab={activeTab}>
    //       <IntermediateFeedback />
    //     </TabPanel>
    //     <TabPanel id={1} activeTab={activeTab}>
    //       <PartnerFeedback />
    //     </TabPanel>
    //     <TabPanel id={2} activeTab={activeTab}>
    //       <ProfessionalFeedback />
    //     </TabPanel>
    //   </ul>
    // </div>
  );
}
